<template>
  <v-app>
    <v-app-bar
            inverted-scroll
            scroll-target=""
            app
    >
      <v-toolbar-title class="headline text-uppercase">
        <a @click="$vuetify.goTo('#Hero')">
       <v-avatar size="32"> <img :src="require('@/assets/Logo-FFW.png')" alt=""/></v-avatar>
        </a>
        <span class="hidden-xs-only">Fight for win</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        text
        href="https://link.clashofclans.com/en?action=OpenClanProfile&tag=L9RU988C"
        target="_blank"
      >
        <v-avatar size="25" style="margin-right: 9px; margin-top: -5px"><img :src="require('@/assets/ClashofClansLogoMinimal.png')" alt=""/></v-avatar>Anfragen
      </v-btn>
    </v-app-bar>
    <v-content>
      <Banner/>
      <AboutUs/>
      <Discord  style="margin-top: 150px"/>
      <Recruit id="recruit"/>
      <Join/>
      <Rules id="rules" style="margin-top: 150px"/>
      <!--  no SSL

      <Statistics class="hidden-md-and-down" style="margin-bottom: 50px"/>

      -->
      <!-- IM AUFBAU DIALOG
      <v-dialog
              v-model="dialog"
              width="500"
      >
        <v-card>
          <v-card-title
                  class="headline grey lighten-2"
                  primary-title

          >
            Im Aufbau
          </v-card-title>

          <v-card-text>
            Hier entsteht gerade die Webseite des <b>Fight for win Clans</b>.<br/>Zurzeit ist die Webseite noch in Arbeit.
            Bugs (Fehler), Schreibfehler oder dergleichen braucht ihr also nicht rückmelden ;-).
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn
                    color="primary"
                    text
                    @click="dialog = false"
            >
              verstanden
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      -->
    </v-content>
    <Footer/>
  </v-app>
</template>

<script>
//import Statistics from './components/Statistics';
import Banner from './components/Banner.vue';
import AboutUs from './components/AboutUs';
import Discord from './components/Discord';
import Rules from './components/Rules'
import Recruit from "./components/Recruit";
import Join from "./components/Join";
import Footer from "./components/Footer";

export default {
  name: 'App',
  components: {
    //Statistics,
    Banner,
    Discord,
    AboutUs,
    Rules,
    Recruit,
    Join,
    Footer,
  },
  data: () => ({
    dialog: true
  }),
};
</script>
